export type AbsenceStatus = "pending" | "validated" | "declined";

export const ABSENCE_STATUS_VALUES: AbsenceStatus[] = ["pending", "validated", "declined"];

export const ABSENCE_STATUS_ICON: Record<AbsenceStatus, JSX.Element> = {
  pending: <span className="dst-icon-hourglass-01 text-warning me-2" />,
  validated: <span className="dst-icon-check text-success me-2" />,
  declined: <span className="dst-icon-x-close text-danger me-2" />,
};

export const getAbsenceStatusIcon = (status: AbsenceStatus) => {
  return ABSENCE_STATUS_ICON[status] || <span className="dst-icon-help-circle me-2" />;
};

export const getAbsenceStatusColor = (status: AbsenceStatus): string => {
  switch (status) {
    case "validated":
      return "text-success";
    case "declined":
      return "text-danger";
    case "pending":
    default:
      return "text-warning";
  }
};

export const getAbsenceBadgeClass = (status: AbsenceStatus): string => {
  switch (status) {
    case "validated":
      return "bg-success";
    case "declined":
      return "bg-danger";
    case "pending":
    default:
      return "bg-secondary";
  }
};
